export const TOGGLE_PROMOTION_MODAL = "promotions/TOGGLE_PROMOTION_MODAL";
export const UPDATE_APPLIED_PROMOTIONS = "promotions/UPDATE_APPLIED_PROMOTIONS";
export const UPDATE_PROMOTION_APPLIED_CART = "promotions/UPDATE_PROMOTION_APPLIED_CART";
export const UPDATE_APPLIED_ORDER_PROMOTIONS = "promotions/UPDATE_APPLIED_ORDER_PROMOTIONS";
export const UPDATE_FREE_ITEMS_CART = "promotions/UPDATE_FREE_ITEMS_CART";
export const VALIDATE_PROMO_CODE = "promotions/VALIDATE_PROMO_CODE";
export const REVALIDATE_PROMO_CODE = "promotions/REVALIDATE_PROMO_CODE";
export const REMOVE_PROMO_RESERVATION = "promotions/REMOVE_PROMO_RESERVATION";
export const UPDATE_APPLIED_PROMO_CODE_DETAILS = "promotions/UPDATE_APPLIED_PROMO_CODE_DETAILS";
